import React from 'react'
import styled from '@emotion/styled'
import { fontFamilies } from '@core/Settings'

export enum TrendingBetFilterEnum {
  TotalBets = 'count',
  TotalSpend = 'cost',
}

type TrendingBetFilterOptions = Readonly<{
  id: number
  name: string
  filter: TrendingBetFilterEnum
  selectable: boolean
}>

const filterSelections: readonly TrendingBetFilterOptions[] = [
  {
    id: 0,
    name: 'Total Bets',
    filter: TrendingBetFilterEnum.TotalBets,
    selectable: true,
  },
  {
    id: 1,
    name: 'Total Spend',
    filter: TrendingBetFilterEnum.TotalSpend,
    selectable: true,
  },
]

export const TrendingBetsFilter: React.FC<{
  initialFilter: TrendingBetFilterEnum
  onChanged: (selectedFilter: TrendingBetFilterEnum) => void
}> = ({ initialFilter, onChanged }) => {
  return (
    <SelectContainer>
      <Select
        data-testid='trending-bets-filter-selection'
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          onChanged(e.target.value as TrendingBetFilterEnum)
        }
        value={initialFilter}
      >
        {filterSelections.map(x => (
          <option key={x.id} value={x.filter} disabled={!x.selectable} hidden={!x.selectable}>
            {x.name}
          </option>
        ))}
      </Select>
    </SelectContainer>
  )
}

// ======
// Styles
// ======

const SelectContainer = styled.div({
  position: 'relative',
  paddingRight: '1rem',

  '&::after': {
    MozOsxFontSmoothing: 'grayscale',
    WebkitFontSmoothing: 'antialiased',
    color: '#cbb5d8',
    content: `'\\76'`,
    display: 'inline-block',
    fontFamily: `'tticons'`,
    fontSize: '11px',
    pointerEvents: 'none',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  '& select': {
    marginRight: '0.5rem',
  },
})

const Select = styled.select({
  fontFamily: fontFamilies.brand,
  appearance: 'none',
  background: 'none',
  color: '#cbb5d8',
  border: 'none',
  fontWeight: 'normal',
  borderBottom: '1px solid #cbb5d8',
})
